import RecomendadosView from './RecomendadosView.vue'
import CreacionRecomendadosView from './CreacionRecomendadosView.vue'
import EdicionRecomendadosView from './EdicionRecomendadosView.vue'

export default [
  {
    path: '',
    component: RecomendadosView
  },
  {
    path: 'nuevo',
    component: CreacionRecomendadosView
  },
  {
    path: 'edicion/:id',
    component: EdicionRecomendadosView
  }
];